import { Period } from './models';

const periods: Period[] = [
  { id: 1, name: '1 day', nameFr: '1 jour' },
  { id: 2, name: '3 days', nameFr: '3 jours'  },
  { id: 3, name: '10 days', nameFr: '10 jours'  },
  { id: 4, name: '20 days', nameFr: '20 jours'  },
  { id: 5, name: '30 days', nameFr: '30 jours'  }
];

export { periods };
